"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var mapStateToProps = function (state) { return ({
    isLoading: state.layout.isLoading,
}); };
var loading = function (props) {
    return (React.createElement("div", { className: "c-loading " + (props.isLoading ? 'c-loading--active' : '') },
        React.createElement("div", { className: "c-loading__balls" },
            React.createElement("div", { className: "c-loading__ball-1" }),
            React.createElement("div", { className: "c-loading__ball-2" }))));
};
exports.default = react_redux_1.connect(mapStateToProps)(loading);
